import { ReactElement } from 'react'
import {
  AddToListStage,
  useAddToListStore,
} from 'src/store/lists/AddToListStore'
import { breakpoints } from 'src/theme/breakpoints'
import styled from 'styled-components'
import { defaultTheme } from 'src/theme'
import { observer } from 'mobx-react-lite'
import Prompt from './Stages/Prompt'
import ValidationInProgress from './Stages/Validation'
import Review from './Stages/Review'

const AddToListScreen = observer((): ReactElement => {
  const addToListStore = useAddToListStore()
  const stage = addToListStore.getStage()

  return (
    <Container>
      {stage === AddToListStage.ADD_PROMPT && <Prompt />}

      {stage == AddToListStage.VALIDATE && <ValidationInProgress />}

      {stage == AddToListStage.REVIEW && <Review />}
    </Container>
  )
})

const Container = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: ${breakpoints.tabletLarge}px) {
    flex-direction: column;
  }
  background: ${defaultTheme.colors.white};
  margin: 20px;
`

export default AddToListScreen
